import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, switchMap } from 'rxjs';
import { AI_SERVICE_BASE_URL } from './constants';
import { InstitutionSummarizationRequest, InstitutionSummarizationResponse } from './models';

@Injectable({
  providedIn: 'root'
})
export class AiPanelRepository {
  private readonly apiBase = AI_SERVICE_BASE_URL;

  constructor(private readonly http: HttpClient) {}

  public createNewChat(): Observable<string> {
    return this.http.post<string>(`${this.apiBase}/chat`, {});
  }

  public getInstitutionProfileSummary(
    bdCompanyId: number | null | undefined,
    ipreoCompanyId: number | null | undefined,
    institutionName?: string
  ): Observable<InstitutionSummarizationResponse[]> {
    return this.createNewChat().pipe(
      switchMap(chatId => {
        const params: InstitutionSummarizationRequest[] = [
          {
            id: chatId,
            institutionSummarizationRequests: [
              {
                bdCompanyId: bdCompanyId?.toString() || '',
                ipreoCompanyId: ipreoCompanyId?.toString() || '',
                institutionName: institutionName || ''
              }
            ]
          }
        ];
        return this.http.post<InstitutionSummarizationResponse[]>(
          `${this.apiBase}/institutionProfileSummaries`,
          params
        );
      })
    );
  }
}
